import { render, staticRenderFns } from "./PatientId.vue?vue&type=template&id=ab310e22"
import script from "./PatientId.vue?vue&type=script&lang=js"
export * from "./PatientId.vue?vue&type=script&lang=js"
import style0 from "./PatientId.vue?vue&type=style&index=0&id=ab310e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports